import React from 'react';

import cn from 'classnames';

import Box from 'components/Box';
import IconButton, { IconButtonSize } from 'components/IconButton';

import './style.scss';

interface IPlayBoxProps {
  classNames: string;
  isPlaying?: boolean;
  isLoading?: boolean;
  isTeaser?: boolean;
  size: IconButtonSize;
}

const PlayBox = ({
  classNames,
  isLoading,
  isPlaying,
  isTeaser,
  size,
  ...props
}: IPlayBoxProps) => (
  <Box center className={classNames} {...props} disabled>
    <div className="PlayButton__icon">
      {isTeaser && !isPlaying && (
        <IconButton icon="Teaser" size={size} loading={isLoading} />
      )}
      {!isTeaser && !isPlaying && (
        <IconButton icon="Playsolid" size={size} loading={isLoading} />
      )}
      {isPlaying && (
        <IconButton icon="Pausesolid" size={size} loading={isLoading} />
      )}
    </div>
  </Box>
);

const ReplayBox = ({
  classNames,
  isPlaying,
  isLoading,
  size,
  ...props
}: IPlayBoxProps) => (
  <Box center className={classNames} {...props}>
    <div className="PlayButton__icon">
      {!isPlaying && (
        <IconButton icon="Replayline" size={size} loading={isLoading} />
      )}
      {isPlaying && (
        <IconButton icon="Pausesolid" size={size} loading={isLoading} />
      )}
    </div>
  </Box>
);

export interface IPlayButtonProps {
  className?: string;
  alreadyListened?: boolean;
  isLoading: boolean;
  isPlaying?: boolean;
  isTeaser?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  hidden?: boolean;
  size: IconButtonSize;
}

const PlayButton = ({
  alreadyListened,
  isLoading,
  isPlaying,
  isTeaser = false,
  className,
  disabled,
  size,
  ...props
}: IPlayButtonProps) => {
  const classNames = cn(className, 'PlayButton', {
    'PlayButton--playing': isPlaying,
    'PlayButton--loading': isLoading && !isPlaying,
    'PlayButton--disabled': disabled,
  });

  return alreadyListened ? (
    <ReplayBox
      classNames={classNames}
      isPlaying={isPlaying}
      isLoading={isLoading}
      size={size}
      {...props}
    />
  ) : (
    <PlayBox
      classNames={classNames}
      isPlaying={isPlaying}
      isLoading={isLoading}
      isTeaser={isTeaser}
      size={size}
      {...props}
    />
  );
};

export default PlayButton;
